import { ProcessKind } from "@bitory-gmbh/bsm";

export enum GSMProcessKind {
  Full = "full",
  Delivery = "delivery",
}

export const ProcessKindList = Object.values(GSMProcessKind);

export function parseProcessKind(str: string): ProcessKind | undefined {
  switch (str.toLowerCase()) {
    case "full":
      return GSMProcessKind.Full;
    case "delivery":
      return GSMProcessKind.Delivery;
    default:
      return undefined;
  }
}
